module.exports = __webpack_public_path__ + "media/images/flags/tr-5993e47165d45f061fd101cdf2a697bf.svg";